module.exports = __webpack_public_path__ + "static/media/icon-burger.7dc59f03.svg";